export default __webpack_public_path__ + "static/media/duplicate-white.8d0e4ef0.svg";